import { InputMultiSelectControl, MultiSelect } from '../../Select'
import { RequestSelect } from '../RequestSelect'

import RequestIcon from '../../../icons/service-request.svg'

function RequestMultiSelect({
  Control = InputMultiSelectControl,
  tagsProps,
  onClear,
  onSelectItem,
  ...restProps
}) {
  return (
    <MultiSelect
      {...restProps}
      Control={Control}
      EntityIcon={RequestIcon}
      Select={RequestSelect}
      tagsProps={{
        ...tagsProps,
        onChange: onSelectItem,
        onClear,
      }}
      onClear={onClear}
      onSelectItem={onSelectItem}
    />
  )
}

export default RequestMultiSelect
